import BaseModelInstance from './base.model'
import { CommissionLevel as ModelDefinition } from './model-definitions'

class CommissionLevel extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default CommissionLevel
